import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  VENUES_ADD_PATH,
  VENUES_PATH,
  VENUES_UPDATE_PATH,
} from "utils/constants/paths";

const Venues = Loadable(React.lazy(() => import("./View")));
const VenuesAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate"))
);

export const VenuesRoute: IRouteItem = {
  path: VENUES_PATH,
  iconName: "Building4",
  element: React.createElement(Venues),
  name: "Venues",
  accessKeys: ["SuperAdmin", "Admin", "ContentManager"],
  children: [
    {
      name: "Add / Update",
      path: VENUES_ADD_PATH,
      element: React.createElement(VenuesAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: VENUES_UPDATE_PATH,
      element: React.createElement(VenuesAddOrUpdate),
      showInDrawer: false,
    },
  ],
};
